import {
  getOneShop,
  getListShopsByZone,
  listShopsByZoneAndCategory,
  listShopsByMultipleCategories,
  searchBarShopsByName,
  GetCategories,
  geoLocationShop,
  getRating,
  getListOfferProducts,
  GetReviewsByEvaluatedID,
  GetReviewsByEvaluatedIDAndDate,
  generalCommissions,
  ordersByShop,
  GetOrdersCommissions,
  GetMthodPayServ,
  GetDataBankShopService
} from "../../Provider";

export function GetBusinessInfoService(id) {
  return getOneShop(id);
}

export function GetBusinessListService(zone) {
  return getListShopsByZone(zone);
}

export function GetBusinessListByCategoryService(zone, category) {
  return listShopsByZoneAndCategory(zone, category);
}

export function GetBusinessListByMultipleCategoriesService(zone, categories) {
  return listShopsByMultipleCategories(zone, categories);
}

export function GetBusinessListByNameService(zone, name) {
  return searchBarShopsByName(zone, name);
}

export function GetListCategoriesService() {
  return GetCategories();
}

export async function GetListOfferProductsService(id){
  return getListOfferProducts(id);
}

export async function GetGeoLocationService(id){
 return geoLocationShop(id);
}

export async function GetRatingShopService(id){
  return getRating(id);
}

export async function GetListReviewsService(id){
  return GetReviewsByEvaluatedID(id);
}

export async function GetListReviewsByDateService(id, date){
  return GetReviewsByEvaluatedIDAndDate(id, date);
}

export async function GetListCommissionsService(zone){
  return generalCommissions(zone);
}

export async function GetCommisionsByShopService(id){
  return ordersByShop(id);
}

export async function GetOrdersByShopService(id){
  return GetOrdersCommissions(id);
}
export async function GetMthodPayService(id){
  return GetMthodPayServ(id);
}
export async function getDataBankShopService(id){
  return GetDataBankShopService(id);
}